import React from 'react'
import './styles.scss'

const WistiaVideo = ({ id }) => {
  if (!id) return null
  return (
    <div className="wistia-video">
      <div className="wistia-video-responsive-wrapper">
        <iframe
          src={`https://fast.wistia.net/embed/iframe/${id}?videoFoam=true`}
          title="Speaker Panel Video"
          allowtransparency="true"
          frameBorder="0"
          scrolling="no"
          className="wistia_embed"
          name="wistia_embed"
          allowFullScreen
          mozallowfullscreen
          webkitallowfullscreen
          oallowfullscreen
          msallowfullscreen
          width="100%"
          height="100%"
        />
      </div>
    </div>
  )
}

export default WistiaVideo
